export enum FieldTypeName {
    STRING = "string",
    BOOL = "bool",
    DATE_RANGE = "date",
    INTEGER = "int",
    STRICT_INTEGER = "sint",
    SELECT = "select",
    GROUPED_SELECT = "groupedSelect",
    JSONB = "jsonb",
}
